var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 11.8912V15.3333C21.6666 15.8 21.6666 16.0334 21.7574 16.2116C21.8373 16.3685 21.9648 16.4959 22.1216 16.5758C22.2999 16.6667 22.5332 16.6667 22.9999 16.6667H26.442M26.6666 18.3235V24.3333C26.6666 25.7335 26.6666 26.4335 26.3941 26.9683C26.1544 27.4387 25.772 27.8212 25.3016 28.0608C24.7668 28.3333 24.0667 28.3333 22.6666 28.3333H17.3333C15.9331 28.3333 15.2331 28.3333 14.6983 28.0608C14.2279 27.8212 13.8454 27.4387 13.6057 26.9683C13.3333 26.4335 13.3333 25.7335 13.3333 24.3333V15.6667C13.3333 14.2665 13.3333 13.5665 13.6057 13.0317C13.8454 12.5613 14.2279 12.1788 14.6983 11.9391C15.2331 11.6667 15.9331 11.6667 17.3333 11.6667H20.0097C20.6212 11.6667 20.9269 11.6667 21.2147 11.7357C21.4698 11.797 21.7136 11.898 21.9373 12.0351C22.1896 12.1897 22.4058 12.4059 22.8382 12.8382L25.495 15.4951C25.9274 15.9275 26.1436 16.1437 26.2982 16.3959C26.4353 16.6196 26.5363 16.8635 26.5975 17.1186C26.6666 17.4063 26.6666 17.712 26.6666 18.3235Z",
    stroke: "#1570EF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.006b7c85510bd41a20628d774913a386.svg";
export { ForwardRef as ReactComponent };